/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { OperationType } from 'relay-runtime';
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type WorkforceOptimizationEntryPointComponent = EntryPointComponent<
	Record<string, OperationType>,
	// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	Record<string, EntryPoint<any, any> | undefined>,
	{},
	{
		cloudId: string;
		projectKey: string;
	}
>;

export const workforceOptimizationEntryPoint: EntryPoint<
	WorkforceOptimizationEntryPointComponent,
	EntryPointRouteParams
> = createEntryPoint({
	root: JSResourceForInteraction<WorkforceOptimizationEntryPointComponent>(
		/* webpackChunkName: "async-servicedesk-workforce-optimization", jiraSpaEntry: "async-servicedesk-workforce-optimization" */ './WorkforceOptimizationPage.tsx',
	),
	getPreloadProps: ({ context: { match }, tenantContext: { cloudId } }: EntryPointRouteParams) => {
		const projectKey = match.params.projectKey ?? '';

		return {
			queries: {},
			extraProps: { cloudId, projectKey },
		};
	},
});
